import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-rootsbedrock',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Roots Bedrock icon</title><path d="M.4 0L0 .4v5.2l.343.343 11.314-1.886L12 4.4V8l11.52-1.92.48-.48V.4l-.4-.4zm.08 9.92L0 10.4v3.2l.343.343L12 12V8zM12 12v4l11.52-1.92.48-.48v-3.2l-.343-.343zM.48 17.92L0 18.4v5.2l.4.4h23.2l.4-.4v-5.2l-.343-.343-11.314 1.886L12 19.6V16L.48 17.92z"/></svg>`,
    styles: []
})
export class SimpleIconsRootsbedrockComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#525DDC';
    @Input() className: string = 'simple-icons-rootsbedrock'
    constructor() {}
    ngOnInit(): void {}
}
